import { FC } from "react";
import { TeamContext } from "../../../types/common";
import { useConfiguration } from "../../../hooks/useConfiguration";
import { Header } from "../../../components/layout";
import { AcademyBranches } from "../../../widgets/mainScreen/AcademyBranches";
import { Timeline } from "./Timeline";
import { TicketsStoryWidget } from "../../../widgets/mainScreen/TicketsStory";

export const TeamHeader: FC = () => {
    const config = useConfiguration();

    let teamTitle = "ФУТБОЛЬНЫЙ КЛУБ «РОДИНА»";
    let linkUrl = "/";
    if (config.teamName === TeamContext.ACADEMY) {
        teamTitle = "АКАДЕМИЯ «РОДИНА»";
    } else if (config.teamName === TeamContext.RODINA_2) {
        teamTitle = "ФУТБОЛЬНЫЙ КЛУБ «РОДИНА-2»";
        linkUrl = "/2/";
    } else if (config.teamName === TeamContext.RODINA_3) {
        teamTitle = "ФУТБОЛЬНЫЙ КЛУБ «РОДИНА-М»";
        linkUrl = "/3/";
    } else if (config.teamName === TeamContext.RODINA_M) {
        teamTitle = "ФУТБОЛЬНЫЙ КЛУБ «РОДИНА» Молодёжка";
        linkUrl = "/youth/";
    } else if (config.teamName === TeamContext.RODINA) {
        teamTitle = "ФУТБОЛЬНЫЙ КЛУБ «РОДИНА»";
        linkUrl = '/rodina/';
    }

    let timeline = null;
    let rightSideElements = null;

    if (config.teamName === TeamContext.ACADEMY) {
        rightSideElements = (
            <AcademyBranches />
        );
    }

    return (
        <>
            <TicketsStoryWidget />
            <Header
                clubTitle={teamTitle}
                timeline={<Timeline team={config.teamName} />}
                onLogoClick={() => window.location.assign(linkUrl)}
                rightSideElements={rightSideElements}
            />
        </>
    );
}